export const DEFAULT_ANIMATION_DURATION = 200
